import "../css/app.css";

//Import Froala Editor plugins
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/word_paste.min.js';

// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';

// Import Froala Editor component
import VueFroala from 'vue-froala-wysiwyg';

import {createApp, h} from 'vue';
import {createInertiaApp} from '@inertiajs/vue3';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import {ZiggyVue} from 'ziggy-js';
import {createPinia} from 'pinia';

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

import axios from 'axios';
import NProgress from 'nprogress';
import VueApexCharts from "vue3-apexcharts";

// Add a request interceptor - add NProgress bar for every axios request
axios.interceptors.request.use((config) => {
    if (!config.ignoreProgress) {
        NProgress.start();  // Start the progress bar only if ignoreProgress is not true
    }
    return config;
});

// Add a response interceptor - remove the NProgress bar for every axios response
axios.interceptors.response.use(
    (response) => {
        if (!response.config.ignoreProgress) {
            NProgress.done(); // Only stop the progress bar if ignoreProgress is not true
        }
        return response;
    },
    (error) => {
        if (!error.config.ignoreProgress) {
            NProgress.done(); // Ensure progress bar is stopped on error as well
        }
        return Promise.reject(error);
    }
);

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';
const pinia = createPinia();

createInertiaApp({
    // TODO: Need to update the title.
    // title: (title) => `${title} - ${appName}`,
    title: (title) => title || `${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({el, App, props, plugin}) {
        return createApp({render: () => h(App, props)})
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(Toast)
            .use(pinia)
            .use(VueFroala)
            .use(VueApexCharts)
            .mount(el);
    },
    progress: {
        color: '#B960FFB2',
        delay: 250, // Only show progress bar if request takes longer than 250ms
        showSpinner: false,
    },
});
